import React from 'react';
interface TimelineEventRlt1Props {
  title: string;
  children: React.ReactNode;
}
const TimelineEventRlt1 = ({
  title,
  children
}: TimelineEventRlt1Props) => {
  return <div className="relative pl-8 mb-10" data-id="element-18253" data-mp="2r0l22cpl8an">
      <div className="absolute left-0 top-2 w-5 h-5 rounded-full bg-gray-800 -ml-2 border-2 border-white" data-id="element-18254" data-mp="2pzas03ioptz"></div>
      <h3 className="text-xl font-serif font-bold text-gray-800 mb-3 border-b border-gray-200 pb-2" data-id="element-18255" data-mp="3twjvl22zb1ik">
        {title}
      </h3>
      <div className="bg-gray-50 p-5 rounded-lg border border-gray-300 shadow-sm" data-id="element-18256" data-mp="3p0bma5bgq2jb">
        {children}
      </div>
    </div>;
};
export default TimelineEventRlt1;